<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-text-field v-model="form.name" :error-messages="nameErrors" label="Name" required @input="$v.form.name.$touch()" @blur="$v.form.name.$touch()"></v-text-field>

					<v-select v-model="form.type" :items="meetingLocationTypes" label="Type" item-text="text" item-value="value" required></v-select>

					<v-textarea v-model="form.description" class="mt-3" required auto-grow rows="3" box label="Description"></v-textarea>

					<v-switch v-model="form.isActive" label="Active"></v-switch>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			meetingLocation: {
				type: Object,
				default: () => ({
					id: null,
					type: 0,
					name: null,
					description: null,
					isActive: true
				})
			},
			dialog: {},
			title: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				form: {
					id: this.meetingLocation.id,
					type: this.meetingLocation.type,
					name: this.meetingLocation.name,
					description: this.meetingLocation.description,
					isActive: this.meetingLocation.isActive
				},
				meetingLocationTypes: [
					{ text: 'Meeting Room', value: 0 },
					{ text: 'Office', value: 1 },
					{ text: 'Other', value: 2 }
				]
			};
		},
		watch: {
			meetingLocation() {
				this.form = {
					id: this.meetingLocation.id,
					type: this.meetingLocation.type,
					name: this.meetingLocation.name,
					description: this.meetingLocation.description,
					isActive: this.meetingLocation.isActive
				};
			}
		},
		computed: {
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Name is required.');
				return errors;
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				name: { required }
			}
		},
		methods: {
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : null,
						name: this.form.name,
						description: this.form.description,
						type: this.form.type,
						isActive: this.form.isActive
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					id: null,
					type: 0,
					name: null,
					description: null,
					isActive: true
				};
			}
		}
	};
</script>

<style></style>
